<common-ui-components-page-layout [showBackIcon]="false">
  <div
    id="cover-image-container"
    class="position-relative"
  >
    <div id="cover-image">
      @if (store()) {
        <ui-api-image
          [imageId]="store()!.coverImageId"
          [width]="'100%'"
          [height]="'100%'"
          class="w-100 h-100 api-image"
          [styles]="{ objectFit: 'cover', filter: isDisabled() ? 'grayscale(1)' : 'unset' }"
          [fallbackImage]="'assets/fallback/store-info-fallback.png'"
        ></ui-api-image>
      }
    </div>
    <div class="position-absolute d-flex cursor-pointer justify-content-space-between">
      <common-icon-dp-icon
        [icon]="'arrow-right'"
        [iconSize]="'24'"
        [iconType]="'linear'"
        [classes]="'text-onback-high'"
        (click)="goBack()"
      ></common-icon-dp-icon>
      @if (store()?.score) {
        <common-rate-count
          [rateAmount]="store()?.score?.score!"
          [rateCount]="store()?.score?.count!"
        ></common-rate-count>
      }
    </div>
  </div>
  <stores-applet-store-overview [store]="store()"></stores-applet-store-overview>
  <stores-applet-store-intro [store]="store()"></stores-applet-store-intro>
  @if (store()) {
    <stores-applet-store-products [store]="store()"></stores-applet-store-products>
  }
</common-ui-components-page-layout>
